import type { SupportedLocale } from './types';

const normalizeLocale = (language?: string): SupportedLocale => {
  if (language?.startsWith('en')) return 'en';
  if (language?.startsWith('ja')) return 'ja';
  return 'zh';
};

export const getLocale = (language?: string): SupportedLocale => normalizeLocale(language);

export const formatContentDate = (date: string, language?: string) => {
  const locale = normalizeLocale(language);
  const formatterLocale = locale === 'zh' ? 'zh-CN' : locale === 'ja' ? 'ja-JP' : 'en-US';
  return new Intl.DateTimeFormat(formatterLocale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};